var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2913",
    "data-name": "Group 2913",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-sessions",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    fill: "#fee9bc",
    stroke: "#fcbe38",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11496",
    "data-name": "Path 11496",
    d: "M293.867,246.694a7.147,7.147,0,1,1,7.147-7.147A7.166,7.166,0,0,1,293.867,246.694Zm0-13.4a6.257,6.257,0,1,0,6.257,6.257A6.264,6.264,0,0,0,293.867,233.29Z",
    transform: "translate(-259.613 -206.502)",
    fill: "#b08423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11483_-_Outline",
    "data-name": "Path 11483 - Outline",
    d: "M293.867,246.894a7.347,7.347,0,1,1,7.347-7.347A7.355,7.355,0,0,1,293.867,246.894Zm0-14.294a6.947,6.947,0,1,0,6.947,6.947A6.955,6.955,0,0,0,293.867,232.6Zm0,13.4a6.457,6.457,0,1,1,6.457-6.457A6.464,6.464,0,0,1,293.867,246Zm0-12.513a6.057,6.057,0,1,0,6.057,6.057A6.064,6.064,0,0,0,293.867,233.49Z",
    transform: "translate(-259.613 -206.502)",
    fill: "#b08423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11497",
    "data-name": "Path 11497",
    d: "M104.287,28.3H95.715c-.81.012-.81-.55-.81-.8l.04-22.841a.61.61,0,0,1,.612-.745H110.3a.47.47,0,0,1,.322.124l4.3,4.2a.449.449,0,0,1,.148.346v4.3a.486.486,0,0,1-.47.47.492.492,0,0,1-.47-.495V8.79L110.1,4.858H95.9v22.5h8.383a.486.486,0,0,1,.47.47.47.47,0,0,1-.47.47Z",
    transform: "translate(-76.314 11.89)",
    fill: "#b08423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11485_-_Outline",
    "data-name": "Path 11485 - Outline",
    d: "M95.69,28.5a.913.913,0,0,1-.86-.407,1.158,1.158,0,0,1-.125-.591l.039-22.82a.756.756,0,0,1,.142-.644.9.9,0,0,1,.67-.321H110.3a.665.665,0,0,1,.463.182l4.3,4.2a.647.647,0,0,1,.209.489v4.3a.67.67,0,1,1-1.34-.025v-4l-3.912-3.816H96.1v22.1h8.183a.687.687,0,0,1,.67.67.671.671,0,0,1-.587.665l-.006.005H95.69ZM95.557,4.118a.507.507,0,0,0-.358.172.37.37,0,0,0-.059.33l0,.022v.022L95.105,27.5a.791.791,0,0,0,.071.39c.03.051.121.208.514.208h8.6a.27.27,0,0,0,.27-.27.288.288,0,0,0-.27-.27H95.7V4.658H110.18l4.149,4.048V12.87a.294.294,0,0,0,.27.295.288.288,0,0,0,.27-.27v-4.3a.251.251,0,0,0-.09-.2l-4.3-4.2a.272.272,0,0,0-.182-.067Z",
    transform: "translate(-76.314 11.89)",
    fill: "#b08423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11498",
    "data-name": "Path 11498",
    d: "M167.984,162.368H177.9a.544.544,0,1,0,0-1.088h-9.917a.544.544,0,0,0,0,1.088Z",
    transform: "translate(-145.602 -138.522)",
    fill: "#b08423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11486_-_Outline",
    "data-name": "Path 11486 - Outline",
    d: "M177.9,162.568h-9.917a.744.744,0,0,1,0-1.488H177.9a.744.744,0,1,1,0,1.488Zm-9.917-1.088a.344.344,0,0,0,0,.688H177.9a.344.344,0,1,0,0-.688Z",
    transform: "translate(-145.602 -138.522)",
    fill: "#b08423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11499",
    "data-name": "Path 11499",
    d: "M169.1,94.608h9.917a.544.544,0,1,0,0-1.088H169.1a.544.544,0,1,0,0,1.088Z",
    transform: "translate(-146.672 -73.755)",
    fill: "#b08423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11487_-_Outline",
    "data-name": "Path 11487 - Outline",
    d: "M179.021,94.808H169.1a.744.744,0,1,1,0-1.488h9.917a.744.744,0,1,1,0,1.488ZM169.1,93.72a.344.344,0,1,0,0,.688h9.917a.344.344,0,1,0,0-.688Z",
    transform: "translate(-146.672 -73.755)",
    fill: "#b08423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11500",
    "data-name": "Path 11500",
    d: "M169.1,231.808h5.812a.544.544,0,1,0,0-1.088H169.1a.544.544,0,1,0,0,1.088Z",
    transform: "translate(-146.672 -204.896)",
    fill: "#b08423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11488_-_Outline",
    "data-name": "Path 11488 - Outline",
    d: "M174.916,232.008H169.1a.744.744,0,1,1,0-1.488h5.812a.744.744,0,1,1,0,1.488ZM169.1,230.92a.344.344,0,1,0,0,.688h5.812a.344.344,0,1,0,0-.688Z",
    transform: "translate(-146.672 -204.896)",
    fill: "#b08423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11501",
    "data-name": "Path 11501",
    d: "M172.157,303.488h-3.61a.544.544,0,1,1,0-1.088h3.635a.549.549,0,0,1,.544.544.571.571,0,0,1-.569.544Z",
    transform: "translate(-146.139 -273.411)",
    fill: "#b08423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11489_-_Outline",
    "data-name": "Path 11489 - Outline",
    d: "M172.157,303.688h-3.61a.744.744,0,1,1,0-1.488h3.635a.745.745,0,0,1,.744.744A.767.767,0,0,1,172.157,303.688Zm-3.61-1.088a.344.344,0,1,0,0,.688h3.61a.371.371,0,0,0,.369-.344.349.349,0,0,0-.344-.344Z",
    transform: "translate(-146.139 -273.411)",
    fill: "#b08423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-dollar-sign",
    "data-name": "Icon awesome-dollar-sign",
    d: "M3.165,3.529,1.532,3.051a.446.446,0,0,1,.125-.874h1a.923.923,0,0,1,.517.159.236.236,0,0,0,.295-.03L4,1.792a.245.245,0,0,0-.027-.37A2.138,2.138,0,0,0,2.663.968V.242A.243.243,0,0,0,2.421,0H1.937A.243.243,0,0,0,1.7.242V.968H1.658A1.657,1.657,0,0,0,.01,2.776,1.731,1.731,0,0,0,1.277,4.236l1.55.454a.446.446,0,0,1-.125.874h-1a.923.923,0,0,1-.517-.159.236.236,0,0,0-.295.03L.36,5.95a.245.245,0,0,0,.027.37A2.138,2.138,0,0,0,1.7,6.774V7.5a.243.243,0,0,0,.242.242h.484A.243.243,0,0,0,2.663,7.5V6.771a1.708,1.708,0,0,0,1.6-1.1,1.66,1.66,0,0,0-1.1-2.142Z",
    transform: "translate(31.944 29.129)",
    fill: "#b08423"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaid);
export default __webpack_public_path__ + "static/media/paid.5ea7ab945a2b4603cf362985c1bf1535.svg";
export { ForwardRef as ReactComponent };